import { render, staticRenderFns } from "./MonthList.vue?vue&type=template&id=bff89394"
import script from "./MonthList.vue?vue&type=script&lang=js"
export * from "./MonthList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports